export default __webpack_public_path__ + "static/media/caret-right.1a70d055.svg";